/**
 *
 * Custom Form Validation
 *
 * Adds custom validation patterns for Abide forms
 *
 *
 *
 */

const Foundation = require('foundation-sites/dist/js/foundation');
const $ = require('jquery');
const EmailValidator = require('./js/utilities/EmailValidator');

const emailValidator = new EmailValidator();

Foundation.Abide.defaults.validators['valid_work_email'] = function( $el, required, parent ){
    return emailValidator.isValid($el.val(), required);
};

Foundation.Abide.defaults.validators['alpha_validator']  = function( $el, required, parent ){

    var regPattern = /^[A-Za-z0-9\s'.)(\\&-]{1,50}$/; //allow ampersand to pattern and numbers
    var input       = $el.val();

    if( !required ) return true;

    return regPattern.test( input );

};

/**
 *
 * Phone validator
 *
 * @param $el
 * @param required
 * @param parent
 * @returns {boolean}
 */
Foundation.Abide.defaults.validators['phone_validator'] = function( $el, required, parent ){

    var regPattern  = /^(?:\+|00)?(?:[0-9]\d{0,3})(?:\ ?)(?:[0-9]\d{6,})$/;
    var input       = $el.val();

    // Remove dots from input phone number
    input = input.split('.').join("");

    // Remove dashes from input phone number
    input = input.split('-').join("");

    // Remove brackets from input phone number
    input = input.split('(').join("");
    input = input.split(')').join("");

    // Keep first space (if after international code), remove others
    let pos = input.search(' ');
    input = input.split(' ').join("");
    if(pos > 0 && pos < 5) {
        input = input.substring(0, pos) + ' ' + input.substring(pos, input.length);
    }

    if( !required && $el.val().trim() == '' ) return true;

    return regPattern.test( input );

};

$(document).foundation();

document.dispatchEvent(new CustomEvent('foundation-has-been-initialized'));
window.FOUNDATION_INITIALIZED = true;
